import { createFileRoute } from "@tanstack/react-router";

import { JsonLd } from "@/components/site/JsonLd";
import { SchoolComparisonPage } from "@/components/site/SchoolComparisonPage";
import { SCHOOL_COMPARISON, comparisonJsonLd } from "@/content/school-comparison";
import { PAGE_META } from "@/content/page-meta";
import { absoluteUrl, seoLinks, ogImage } from "@/lib/seo";

const PATH = "/svensk-internationell-eller-spansk-skola";
const meta = PAGE_META["cmp:sv"];

export const Route = createFileRoute("/svensk-internationell-eller-spansk-skola")({
  head: () => ({
    meta: [
      { title: meta.title },
      { name: "description", content: meta.description },
      { property: "og:title", content: meta.title },
      { property: "og:description", content: meta.description },
      { property: "og:type", content: "article" },
      { property: "og:url", content: absoluteUrl(PATH) },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:locale", content: "sv_SE" },
      ...ogImage(),
    ],
    links: seoLinks(PATH),
  }),
  component: ComparisonSvRoute,
});

function ComparisonSvRoute() {
  const content = SCHOOL_COMPARISON.sv;
  return (
    <>
      <JsonLd scripts={comparisonJsonLd(content, absoluteUrl(PATH), "sv")} />
      <SchoolComparisonPage locale="sv" content={content} />
    </>
  );
}
